/**
 * Odoo Import API services
 */

import { apiClient } from './client';

export interface OdooConnectionRequest {
  url: string;
  database: string;
  username: string;
  password: string;
}

export interface OdooConnectionResponse {
  success: boolean;
  uid?: number;
  name?: string;
  company?: string;
  error?: string;
}

export interface OdooModel {
  model: string;
  name: string;
  description: string;
}

export interface OdooImportRequest {
  url: string;
  database: string;
  username: string;
  password: string;
  model: string;
  limit?: number;
}

export interface OdooImportResponse {
  success: boolean;
  imported: number;
  skipped: number;
  errors: number;
  message: string;
}

export interface OdooFileInfo {
  filename: string;
  path: string;
  size: number;
}

export interface OdooFileImportRequest {
  filename: string;
  limit?: number;
}

export const odooApi = {
  testConnection: async (data: OdooConnectionRequest): Promise<OdooConnectionResponse> => {
    const response = await apiClient.post('/v1/odoo/test-connection', data);
    return response.data;
  },

  getModels: async (): Promise<OdooModel[]> => {
    const response = await apiClient.get('/v1/odoo/models');
    return response.data;
  },

  importData: async (data: OdooImportRequest): Promise<OdooImportResponse> => {
    const response = await apiClient.post('/v1/odoo/import', data);
    return response.data;
  },

  // File-based import endpoints
  getFiles: async (): Promise<OdooFileInfo[]> => {
    const response = await apiClient.get('/v1/odoo/files');
    return response.data;
  },

  importFromFile: async (data: OdooFileImportRequest): Promise<OdooImportResponse> => {
    const response = await apiClient.post('/v1/odoo/import-file', data);
    return response.data;
  },
};
